import CrashGame from "./CrashGame";
export default CrashGame;
